import Form from "@/components/Form";
import { QueryTable } from "@/components/query-table/QueryTable";
import SaveButton from "@/components/SaveButton";
import { useProjectLimitsContext } from "./ProjectLimitsContext";
import { ProjectLimitUpsertButton } from "./ProjectLimitUpsertButton";

const ProjectLimitForm = () => {
  const { form, handleChangeLimitSubmit } = useProjectLimitsContext();

  return (
    <Form
      form={form}
      handleSubmit={handleChangeLimitSubmit}
      className="h-full gap-1"
    >
      <QueryTable.Content>
        <QueryTable.Status>
          <ProjectLimitUpsertButton />
        </QueryTable.Status>
      </QueryTable.Content>
      <footer className="flex p-2 justify-end gap-6">
        <SaveButton />
      </footer>
    </Form>
  );
};

export default ProjectLimitForm;
